import { BrowserModule, Title } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

// RF Modules
import { AuthenticationModule } from './modules/authentication/authentication.module';
import { DashboardModule } from './modules/dashboard/dashboard.module';
import { ReportModule } from './modules/report/report.module';
import { SharedModule } from './modules/shared/shared.module';
import { VirtualTerminalModule } from './modules/virtual-terminal/virtual-terminal.module';
import { TemplateModule } from './modules/template/template.module';
import { AdminModule } from './modules/admin/admin.module';
import { EditorModule } from './modules/editor/editor.module';
import { TransferModule } from './modules/transfer/transfer.module';
import { PriceCheckModule } from './modules/price-check/price-check.module';
import { ErrorHandlerModule } from './modules/errors/error-handler-module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    AppRoutingModule,
    AuthenticationModule,
    DashboardModule,
    ReportModule,
    SharedModule,
    VirtualTerminalModule,
    TemplateModule,
    AdminModule,
    EditorModule,
    TransferModule,
    PriceCheckModule,
    ErrorHandlerModule,
    MatSnackBarModule,
    BrowserAnimationsModule,
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: environment.serviceWorker === true,
      // Register the ServiceWorker as soon as the app is stable
      // or after 30 seconds (whichever comes first).
      registrationStrategy: 'registerWhenStable:30000'
    })
  ],
  providers: [Title],
  bootstrap: [AppComponent]
})
export class AppModule { }
